export const LIGHTSTEP_ACCESS_TOKEN = '3e88a09bcb0a33f3579cd7370287d0b0';
export const LIGHTSTEP_TEST_ACCESS_TOKEN = '38e8dd4e360c052c844728c9f9f4c38e';
export const LIGHTSTEP_SATELLITE_ENDPOINT = 'tracing.spotify.com';
export const LIGHTSTEP_SATELLITE_TEST_ENDPOINT = 'tracing-staging.spotify.net';
//# sourceMappingURL=config.js.map